import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import calendarPreview from '../../../../../assets/images/calendarPreview.svg';
import {ChannelModel} from '../../../../../models/api/channelModel';

/*
 * Props.
 */

interface CalendarInviteAuthPromptProps {
  channel: ChannelModel;
  onGoToReAuthChannelSettingsClick: Handler;
}

/*
 * Styles.
 */

const StyledWrapperDiv = styled.div`
  position: relative;
  margin: 0px 16px 16px 16px;
  padding: 24px 28px;
  overflow: hidden;
  border: 1px solid ${(p) => p.theme.greys.shade40};
  border-radius: 16px;
`;

const StyledOverlayDiv = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  height: 100%;
  width: 350px;

  padding-left: 110px;
  padding-right: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  font-size: 14px;
  line-height: 20px;
  color: ${(p) => p.theme.greys.shade70};
  background: linear-gradient(
    to right,
    transparent,
    ${(p) => p.theme.greys.white} 80px,
    ${(p) => p.theme.greys.white} 100%
  );
`;

const StyledButtonWrapperDiv = styled.div`
  display: flex;
  margin-top: 8px;
  margin-left: -12px;
`;

/*
 * Component.
 */

export const CalendarInviteAuthPrompt: FC<CalendarInviteAuthPromptProps> = (props) => (
  <StyledWrapperDiv>
    <img src={calendarPreview} alt="" />
    <StyledOverlayDiv>
      <Trans id="calendar-auth-prompt-preview">
        {`Add calendar permissions to your ${props.channel.displayName} inbox to see a preview of your calendar.`}
      </Trans>
      <StyledButtonWrapperDiv>
        <Button variant={ButtonVariantsEnum.LINK} onClick={props.onGoToReAuthChannelSettingsClick}>
          <Trans id="calendar-auth-settings">Go to Settings</Trans>
        </Button>
      </StyledButtonWrapperDiv>
    </StyledOverlayDiv>
  </StyledWrapperDiv>
);
